import Script from 'next/script';

export default function Analytics(): JSX.Element | null {
  const id = process.env.NEXT_PUBLIC_ANALYTICS_ID;
  const src = process.env.NEXT_PUBLIC_ANALYTICS_SRC;

  if (!id || !src) {
    return null;
  }

  return (
    <Script
      strategy="beforeInteractive"
      data-website-id={id}
      src={src}
      async
      defer
    />
  );
}
